<template>
  <ComboPicker
    :label="orientation == 'horizontal' ? null : label"
    strings="ação;a"
    icon="mdi-gesture-tap"
    :bothIcons="orientation == 'horizontal'"
    :value="value"
    @input="(v) => $emit('input', v)"
    :whenEmpty="orientation == 'horizontal' ? 'Todas as ações' : '(Todas)'"
    types="grouped-items"
    :tags="[]"
    :items="allItems"
  />
</template>

<script>
import ComboPicker from 'oderon-vue/cpts/pickers/ComboPicker'

export default {
  components: {
    ComboPicker
  },
  props: {
    label: { type: String, default: 'Ação no Objeto' },
    orientation: { type: String, default: 'horizontal' },
    value: {}
  },
  mounted() {
    this.fetchData()
  },
  data() {
    return {
      allItems: []
    }
  },
  methods: {
    async fetchData() {
      let rows = [
        { name: 'Criação', id: 'create' },
        { name: 'Alteração', id: 'update' },
        { name: 'Remoção', id: 'delete' },
        { name: 'Embarque', id: 'embed' },
        { name: '(Veículo) Bloqueio', id: 'lock' },
        { name: '(Veículo) Desbloqueio', id: 'unlock' },
        { name: '(Poly) Alteração de pontos', id: 'updatePoints' },
        { name: '(Poly) Alteração de tolerância', id: 'updateTolerance' },
        { name: '(Occurs) Limpeza de ocorrências', id: 'cleanOccurs' }
      ]

      this.allItems = rows
    }
  }
}
</script>

<style></style>
